<template>
  <aside class="main-sidebar">
    <section class="sidebar">
      <logo />
      <ul
        class="sidebar-menu overflow-auto"
        v-bind:style="{ height: leftnaveHeight + 'px' }"
      >
        <li class="header">Navigation Menu</li>
        <menu-item
          v-for="item in menuItem"
          :key="item.id"
          v-bind:item="item"
        ></menu-item>
      </ul>
    </section>
  </aside>
</template>
<script>
import menuitem from "./MenuItem";
import logo from "./logo";
export default {
  components: {
    "menu-item": menuitem,
    logo,
  },
  data: function () {
    return {
      open: false,
      leftnaveHeight: 400,
    };
  },
  methods: {
    async getDataOnload() {
      await this.$store.dispatch("loadMenu");
      await this.$store.dispatch("loadInitialData");
      // await this.$store.dispatch("vehicle/loadVehicles");
      // this.$store.dispatch('settings/fetchSpeedLimit');
      // this.$store.dispatch('userManagement/loadUserRoles');
      // this.$store.dispatch('userManagement/loadUsers');
      // this.$store.dispatch('vehicleUserMap/loadVehicleUserMap');
      // this.$store.dispatch('startConnection');
      // this.$store.dispatch('settings/getVehicleSpeedLimitColors');
      // this.$store.dispatch('sosList/fetchSosCount');
      // this.$store.dispatch('sosList/startTimer');
    },
    toggle() {
      this.open = !this.open;
    },
    handleResize: function () {
      this.leftnaveHeight = window.innerHeight - 60;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  created: function () {
    this.getDataOnload();
  },
  computed: {
    isShow() {
      return this.open ? "show" : "hide";
    },
    menuItem() {
      return this.$store.state.menuItem;
    },
  },
};
</script>
